<app-header></app-header>
<ion-content scroll-y="false">
  <div #mainDivScroll class="container">
    <ng-container *ngIf="vm$ | async; let vm">
      <ion-header class="review-payment-header" data-cy="review-payment-header">
        <ion-grid [fixed]="true">
          <ion-row
            *ngIf="platformService?.platformType === platformService?.platformEnum.desktop"
          >
            <ion-col size="12">
              <app-breadcrumbs [breadcrumbs]="vm.breadcrumbs"></app-breadcrumbs>
            </ion-col>
          </ion-row>

          <ion-row
            class="header__title-row"
            [ngClass]="{'is-windows': platformService?.isWindows(), 'is-tablet': platformService?.platformType === platformService?.platformEnum.tablet }"
          >
            <ion-col size="12">
              <h1 class="page-title-oswald" data-cy="title-text">
                {{'i18n.payments.reviewAndSubmit.title'| translate}}
              </h1>
              <ng-container *ngIf="showSkeleton">
                <ion-col
                  class="header-skeleton"
                  data-cy="review-payment-header-skeleton"
                  size-lg="5"
                  size-md="6"
                  size-sm="7"
                  size-xs="7"
                >
                  <ion-skeleton-text animated></ion-skeleton-text>
                  <ion-skeleton-text animated></ion-skeleton-text>
                </ion-col>
              </ng-container>
              <ng-container *ngIf="!showSkeleton">
                <ion-item
                  *ngIf="!vm.isBanksEditable && !vm.isSubmitEnabled"
                  class="banner-note"
                >
                  <ion-label data-cy="submit-not-enabled-note-text">
                    <span class="note-bold">
                      {{'i18n.common.note' | translate }}
                    </span>
                    <span class="note-regular">
                      {{ 'i18n.payments.reviewAndSubmit.submitNotEnabled' |
                      translate }}
                    </span>
                    <span class="note-bold">
                      {{
                      'i18n.payments.reviewAndSubmit.submitNotEnabledContactNumber'
                      | translate }}
                    </span>
                  </ion-label>
                </ion-item>

                <h6 data-cy="review-payment-subtitle">
                  {{'i18n.payments.reviewAndSubmit.subtitle'| translate}}
                </h6>
              </ng-container>
            </ion-col>
          </ion-row>

          <ion-row
            *ngIf="!showSkeleton"
            class="information-row"
            [ngClass]="{'is-tablet': platformService?.platformType === platformService?.platformEnum.tablet }"
          >
            <ion-col size-lg="6" size-md="5" size-xs="12">
              <section
                class="information-section"
                data-cy="information-section"
                [ngClass]="{'is-tablet': platformService?.platformType === platformService?.platformEnum.tablet}"
              >
                <ion-row>
                  <ion-col size="12">
                    <span data-cy="payment-source-label">
                      {{'i18n.payments.reviewAndSubmit.paymentSource'|
                      translate}}&nbsp;</span
                    >
                    <span data-cy="payment-source-value"
                      >{{ vm.overallCustomerBankAccounts.length > 1 ?
                      ('i18n.payments.reviewAndSubmit.multiple' | translate) :
                      '' }}{{ vm.overallCustomerBankAccounts.length === 1 ?
                      (vm.overallCustomerBankAccounts[0].nickName ?
                      vm.overallCustomerBankAccounts[0].nickName :
                      vm.overallCustomerBankAccounts[0].bankName) : '' }}{{
                      vm.overallCustomerBankAccounts.length === 0 ?
                      ('i18n.payments.reviewAndSubmit.notSelected' | translate)
                      : '' }}</span
                    >
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12">
                    <span data-cy="account-label">
                      {{'i18n.payments.reviewAndSubmit.numberOfCustomers'|
                      translate}}&nbsp;</span
                    >
                    <span data-cy="account-value"
                      >{{vm.nonAutoPayCustomerCount}}</span
                    >
                  </ion-col>
                </ion-row>
                <ion-row>
                  <ion-col size="12">
                    <span
                      data-cy="transaction-number-label"
                      class="information-title"
                    >
                      {{'i18n.payments.reviewAndSubmit.numberOfTransactions'|
                      translate}}&nbsp;</span
                    >
                    <span data-cy="transaction-number-value"
                      >{{ vm.nonAutoPayTransactionCount }}</span
                    >
                  </ion-col>
                </ion-row>
              </section>
            </ion-col>
            <ion-col size-lg="6" size-md="7" size-xs="12">
              <div class="submit-payment__right-side">
                <!-- Input date -->
                <div
                  class="input-payment-date"
                  [ngClass]="{'is-tablet': platformService?.platformType === platformService?.platformEnum.tablet }"
                  data-cy="date-range"
                >
                  <div
                    data-cy="change-date-button"
                    class="usf-outline-green-date-range"
                    (click)="presentCalendarPopover($event)"
                  >
                    <ion-icon
                      class="date-range-icon"
                      name="calendar-outline"
                    ></ion-icon>
                    <p class="date-range-content">
                      {{'i18n.payments.reviewAndSubmit.paymentDate'|
                      translate}}:
                      <span class="date-range"
                        >{{selectedPaymentDate.format('L') ??
                        "MM/DD/YYYY"}}</span
                      >
                    </p>
                  </div>
                </div>
                <!-- Input date -->
                <ng-container
                  *ngIf="platformService?.platformType !== platformService?.platformEnum.mobile"
                  [ngTemplateOutlet]="submitPaymentTemplate"
                  [ngTemplateOutletContext]="{ totalAmount: vm.totalAmount }"
                ></ng-container>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-header>

      <div class="gray-content-bg" data-cy="review-payment-content">
        <ion-grid [fixed]="true">
          <app-customer-summary-section
            [accordionValues]="vm.autoPayCustomerNumbers"
            [customers]="vm.customers"
            [isBanksEditable]="vm.isBanksEditable"
            [transactions]="vm.transactions"
            [isLoading]="showSkeleton"
            [showOrderNumber]="vm.showOrderNumber"
            [totalAmount]="vm.totalAmount"
            [isPaymentPreferencesOn]="vm.isPaymentPreferencesOn"
            [isBankRoutingValidationOn]="vm.isBankRoutingValidationOn"
          ></app-customer-summary-section>
          <ng-container
            *ngIf="platformService?.platformType === platformService?.platformEnum.mobile && !showSkeleton"
            [ngTemplateOutlet]="submitPaymentTemplate"
            [ngTemplateOutletContext]="{ totalAmount: vm.totalAmount }"
          ></ng-container>
        </ion-grid>
      </div>
      <app-footer></app-footer>
    </ng-container>
  </div>
</ion-content>

<ng-template #submitPaymentTemplate let-totalAmount="totalAmount">
  <section
    class="submit-payment__section"
    [ngClass]="{'is-tablet': platformService?.platformType === platformService?.platformEnum.tablet }"
  >
    <ion-button
      [disabled]="!isSubmitEnabled || totalAmount <= 0"
      [ngClass]="(isSubmitEnabled && totalAmount>0) ? 'usf-fill-green-button' : 'usf-fill-disabled-button'"
      data-cy="submit-payment"
      (click)="submitPayment()"
    >
      {{ 'i18n.payments.reviewAndSubmit.submitPayment' | translate }}
    </ion-button>
    <span data-cy="notice-terms-and-conditions"
      >{{'i18n.payments.reviewAndSubmit.noticeTermsAndConditions'| translate}}
      <a
        data-cy="terms-and-conditions-link"
        href="https://www.usfoods.com/content/dam/usf/EC/R4/documents/index.html"
        target="_blank"
        >{{'i18n.payments.reviewAndSubmit.termsAndConditions'| translate}}</a
      >
    </span>
  </section>
</ng-template>

<div class="top-button-container" *ngIf="vm$ | async; let vm">
  <app-top-button
    [mainScroll]="mainScroll"
    [isMobile]="platformService?.platformType === platformService?.platformEnum.mobile"
  ></app-top-button>
</div>
